import * as React from "react";
import { TextBox } from "../../forms/informedv4/TextBoxV4";

export interface MetricsForm {
    TargetSubjects: number;
    TargetSessions: number;
}

export const StudyMetricsForm = () => {
    return (
        <>
            <div className="row">
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label htmlFor="Name">Target Participant Count</label>
                    <TextBox
                        id="TargetSubjects"
                        name="TargetSubjects"
                        field="TargetSubjects"
                        type="number"
                        required
                    />
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label htmlFor="Name">Target Session Count</label>
                    <TextBox
                        id="TargetSessions"
                        name="TargetSessions"
                        field="TargetSessions"
                        type="number"
                        required
                    />
                </div>
            </div>
        </>
    );
}
